import { useScheduleV2QueryUpdaters } from '../query-updaters';

export const useScheduleV2InvalidateQueries = () => {
  const { invalidateQueries } = useScheduleV2QueryUpdaters();

  const invalidateWaitlistCount = (locationId?: string) =>
    invalidateQueries({
      endpointName: 'Count',
      queryFilters: {
        exact: false,
        predicate: ({ queryKey }) => {
          const request = queryKey[2];
          return (request.locationIds ?? []).includes(locationId || '');
        },
      },
    });

  const invalidateWaitlistList = (locationId?: string) =>
    invalidateQueries({
      endpointName: 'List',
      queryFilters: {
        exact: false,
        predicate: ({ queryKey }) => {
          const request = queryKey[2];
          return request.locationId === locationId;
        },
      },
    });

  return {
    invalidateWaitlistCount,
    invalidateWaitlistList,
  };
};
